var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _rect, _rect2, _path95, _path96, _mask, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolyacrylamideGel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 64,
    viewBox: "0 0 70 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.08322 6.72705L7.40625 6.72705L7.40625 14.2073L9.08322 14.2073L9.08322 6.72705Z",
    fill: "#4CD38B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9326 6.72705L11.2556 6.72705L11.2556 14.2073L12.9326 14.2073L12.9326 6.72705Z",
    fill: "#4CD38B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7802 6.72705L15.1033 6.72705L15.1033 14.2073L16.7802 14.2073L16.7802 6.72705Z",
    fill: "#4CD38B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6294 6.72705L18.9524 6.72705L18.9524 14.2073L20.6294 14.2073L20.6294 6.72705Z",
    fill: "#4CD38B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4787 6.72705L22.8018 6.72705L22.8018 14.2073L24.4787 14.2073L24.4787 6.72705Z",
    fill: "#4CD38B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3266 6.72705L26.6497 6.72705L26.6497 14.2073L28.3266 14.2073L28.3266 6.72705Z",
    fill: "#4CD38B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.176 6.72705L30.499 6.72705L30.499 14.2073L32.176 14.2073L32.176 6.72705Z",
    fill: "#4CD38B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0251 6.72705L34.3481 6.72705L34.3481 14.2073L36.0251 14.2073L36.0251 6.72705Z",
    fill: "#4CD38B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.873 6.72705L38.196 6.72705L38.196 14.2073L39.873 14.2073L39.873 6.72705Z",
    fill: "#4CD38B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7221 6.72705L42.0452 6.72705L42.0452 14.2073L43.7221 14.2073L43.7221 6.72705Z",
    fill: "#4CD38B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5715 6.72705L45.8945 6.72705L45.8945 14.2073L47.5715 14.2073L47.5715 6.72705Z",
    fill: "#4CD38B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4194 6.72705L49.7424 6.72705L49.7424 14.2073L51.4194 14.2073L51.4194 6.72705Z",
    fill: "#4CD38B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2685 6.72705L53.5916 6.72705L53.5916 14.2073L55.2685 14.2073L55.2685 6.72705Z",
    fill: "#4CD38B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1179 6.72705L57.4409 6.72705L57.4409 14.2073L59.1179 14.2073L59.1179 6.72705Z",
    fill: "#4CD38B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9673 6.72705L61.2903 6.72705L61.2903 14.2073L62.9673 14.2073L62.9673 6.72705Z",
    fill: "#4CD38B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08347 5.25244L7.40649 5.25244L7.40649 12.7327L9.08347 12.7327L9.08347 5.25244Z",
    fill: "#51E094"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9326 5.25244L11.2556 5.25244L11.2556 12.7327L12.9326 12.7327L12.9326 5.25244Z",
    fill: "#51E094"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7805 5.25244L15.1035 5.25244L15.1035 12.7327L16.7805 12.7327L16.7805 5.25244Z",
    fill: "#51E094"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6299 5.25244L18.9529 5.25244L18.9529 12.7327L20.6299 12.7327L20.6299 5.25244Z",
    fill: "#51E094"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M24.479 5.25244L22.802 5.25244L22.802 12.7327L24.479 12.7327L24.479 5.25244Z",
    fill: "#51E094"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3269 5.25244L26.6499 5.25244L26.6499 12.7327L28.3269 12.7327L28.3269 5.25244Z",
    fill: "#51E094"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1762 5.25244L30.4993 5.25244L30.4993 12.7327L32.1762 12.7327L32.1762 5.25244Z",
    fill: "#51E094"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0254 5.25244L34.3484 5.25244L34.3484 12.7327L36.0254 12.7327L36.0254 5.25244Z",
    fill: "#51E094"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8733 5.25244L38.1963 5.25244L38.1963 12.7327L39.8733 12.7327L39.8733 5.25244Z",
    fill: "#51E094"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7224 5.25244L42.0454 5.25244L42.0454 12.7327L43.7224 12.7327L43.7224 5.25244Z",
    fill: "#51E094"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5718 5.25244L45.8948 5.25244L45.8948 12.7327L47.5718 12.7327L47.5718 5.25244Z",
    fill: "#51E094"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4196 5.25244L49.7427 5.25244L49.7427 12.7327L51.4196 12.7327L51.4196 5.25244Z",
    fill: "#51E094"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M55.269 5.25244L53.592 5.25244L53.592 12.7327L55.269 12.7327L55.269 5.25244Z",
    fill: "#51E094"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1181 5.25244L57.4412 5.25244L57.4412 12.7327L59.1181 12.7327L59.1181 5.25244Z",
    fill: "#51E094"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9675 5.25244L61.2905 5.25244L61.2905 12.7327L62.9675 12.7327L62.9675 5.25244Z",
    fill: "#51E094"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08322 2.25L7.40625 2.25L7.40625 9.73026L9.08322 9.73026L9.08322 2.25Z",
    fill: "#45BF80"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9326 2.25L11.2556 2.25L11.2556 9.73026L12.9326 9.73026L12.9326 2.25Z",
    fill: "#45BF80"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7802 2.25L15.1033 2.25L15.1033 9.73026L16.7802 9.73026L16.7802 2.25Z",
    fill: "#45BF80"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6294 2.25L18.9524 2.25L18.9524 9.73026L20.6294 9.73026L20.6294 2.25Z",
    fill: "#45BF80"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4787 2.25L22.8018 2.25L22.8018 9.73026L24.4787 9.73026L24.4787 2.25Z",
    fill: "#45BF80"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3266 2.25L26.6497 2.25L26.6497 9.73026L28.3266 9.73026L28.3266 2.25Z",
    fill: "#45BF80"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M32.176 2.25L30.499 2.25L30.499 9.73026L32.176 9.73026L32.176 2.25Z",
    fill: "#45BF80"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0251 2.25L34.3481 2.25L34.3481 9.73026L36.0251 9.73026L36.0251 2.25Z",
    fill: "#45BF80"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M39.873 2.25L38.196 2.25L38.196 9.73026L39.873 9.73026L39.873 2.25Z",
    fill: "#45BF80"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7221 2.25L42.0452 2.25L42.0452 9.73026L43.7221 9.73026L43.7221 2.25Z",
    fill: "#45BF80"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5715 2.25L45.8945 2.25L45.8945 9.73026L47.5715 9.73026L47.5715 2.25Z",
    fill: "#45BF80"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4194 2.25L49.7424 2.25L49.7424 9.73026L51.4194 9.73026L51.4194 2.25Z",
    fill: "#45BF80"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2685 2.25L53.5916 2.25L53.5916 9.73026L55.2685 9.73026L55.2685 2.25Z",
    fill: "#45BF80"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1179 2.25L57.4409 2.25L57.4409 9.73026L59.1179 9.73026L59.1179 2.25Z",
    fill: "#45BF80"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9673 2.25L61.2903 2.25L61.2903 9.73026L62.9673 9.73026L62.9673 2.25Z",
    fill: "#45BF80"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8759 8.64809L6.49777 8.64809C6.03825 8.64809 5.66675 8.28094 5.66675 7.82678L5.66675 0.821311C5.66675 0.367157 6.03825 0 6.49777 -1.14716e-10L63.8744 -8.03504e-09C64.334 -8.09847e-09 64.7055 0.367157 64.7055 0.821311L64.7055 7.82678C64.7069 8.28094 64.334 8.64809 63.8759 8.64809Z",
    fill: "#4CD38B"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8759 8.64809L6.49777 8.64809C6.03825 8.64809 5.66675 8.28094 5.66675 7.82678L5.66675 0.821311C5.66675 0.367157 6.03825 0 6.49777 -1.14716e-10L63.8744 -8.03504e-09C64.334 -8.09847e-09 64.7055 0.367157 64.7055 0.821311L64.7055 7.82678C64.7069 8.28094 64.334 8.64809 63.8759 8.64809Z",
    fill: "#4CD38B"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8759 4.32478L6.49777 4.32478C6.03825 4.32478 5.66675 3.95615 5.66675 3.502L5.66675 0.821311C5.66675 0.367157 6.03825 0 6.49777 -1.14716e-10L63.8744 -8.03504e-09C64.334 -8.09847e-09 64.7055 0.367157 64.7055 0.821311L64.7055 3.502C64.7069 3.95615 64.334 4.32478 63.8759 4.32478Z",
    fill: "#54E899"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7069 2.25L5.66675 2.25L5.66675 5.94811L64.7069 5.94811L64.7069 2.25Z",
    fill: "#51E094"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9.09825 8.69971L8.50146 8.69971L8.50146 14.1555L9.09825 14.1555L9.09825 8.69971Z",
    fill: "#58F4A3"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M12.9774 8.69971L12.2314 8.69971L12.2314 14.1555L12.9774 14.1555L12.9774 8.69971Z",
    fill: "#58F4A3"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M16.7074 8.69971L16.1106 8.69971L16.1106 14.1555L16.7074 14.1555L16.7074 8.69971Z",
    fill: "#58F4A3"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M20.5865 8.69971L19.9897 8.69971L19.9897 14.1555L20.5865 14.1555L20.5865 8.69971Z",
    fill: "#58F4A3"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M24.4657 8.69971L23.8689 8.69971L23.8689 14.1555L24.4657 14.1555L24.4657 8.69971Z",
    fill: "#58F4A3"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M28.3446 8.69971L27.7478 8.69971L27.7478 14.1555L28.3446 14.1555L28.3446 8.69971Z",
    fill: "#58F4A3"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M32.2238 8.69971L31.4778 8.69971L31.4778 14.1555L32.2238 14.1555L32.2238 8.69971Z",
    fill: "#58F4A3"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M35.9537 8.69971L35.3569 8.69971L35.3569 14.1555L35.9537 14.1555L35.9537 8.69971Z",
    fill: "#58F4A3"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M39.8329 8.69971L39.2361 8.69971L39.2361 14.1555L39.8329 14.1555L39.8329 8.69971Z",
    fill: "#58F4A3"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M43.7118 8.69971L43.115 8.69971L43.115 14.1555L43.7118 14.1555L43.7118 8.69971Z",
    fill: "#58F4A3"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M47.5912 8.69971L46.9944 8.69971L46.9944 14.1555L47.5912 14.1555L47.5912 8.69971Z",
    fill: "#58F4A3"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M51.4704 8.69971L50.7244 8.69971L50.7244 14.1555L51.4704 14.1555L51.4704 8.69971Z",
    fill: "#58F4A3"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M55.2001 8.69971L54.6033 8.69971L54.6033 14.1555L55.2001 14.1555L55.2001 8.69971Z",
    fill: "#58F4A3"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M59.0792 8.69971L58.4824 8.69971L58.4824 14.1555L59.0792 14.1555L59.0792 8.69971Z",
    fill: "#58F4A3"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M62.9584 8.69971L62.3616 8.69971L62.3616 14.1555L62.9584 14.1555L62.9584 8.69971Z",
    fill: "#58F4A3"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M63.8789 8.64809L62.8584 8.64809L61.6648 5.94676L61.6648 2.25013L62.8584 -1.64762e-10L63.8819 -3.06046e-10C64.3384 -3.69068e-10 64.7084 0.365682 64.7084 0.816887L64.7084 7.8312C64.7069 8.28241 64.3369 8.64809 63.8789 8.64809Z",
    fill: "#58F4A3"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M6.49479 8.64809L7.5153 8.64809L8.70887 5.94676L8.70887 2.25013L7.5153 -2.55175e-10L6.4933 -1.14098e-10C6.03676 0 5.66675 0.365682 5.66675 0.816887L5.66675 7.8312C5.66675 8.28241 6.03676 8.64809 6.49479 8.64809Z",
    fill: "#58F4A3"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72455 8.15575C7.05662 8.15575 7.32582 7.8897 7.32582 7.56152C7.32582 7.23333 7.05662 6.96729 6.72455 6.96729C6.39249 6.96729 6.12329 7.23333 6.12329 7.56152C6.12329 7.8897 6.39249 8.15575 6.72455 8.15575Z",
    fill: "#003E6B"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5685 1.68114C63.9006 1.68114 64.1698 1.4151 64.1698 1.08691C64.1698 0.758723 63.9006 0.492676 63.5685 0.492676C63.2365 0.492676 62.9673 0.758723 62.9673 1.08691C62.9673 1.4151 63.2365 1.68114 63.5685 1.68114Z",
    fill: "#003E6B"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5685 8.15575C63.9006 8.15575 64.1698 7.8897 64.1698 7.56152C64.1698 7.23333 63.9006 6.96729 63.5685 6.96729C63.2365 6.96729 62.9673 7.23333 62.9673 7.56152C62.9673 7.8897 63.2365 8.15575 63.5685 8.15575Z",
    fill: "#003E6B"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8194 1.62609C63.8806 1.53319 63.9164 1.4226 63.9164 1.30464C63.9164 0.975822 63.6478 0.710408 63.3151 0.710408C63.2256 0.710408 63.1405 0.731051 63.0645 0.76644C63.1719 0.602767 63.3569 0.493652 63.5687 0.493652C63.9014 0.493652 64.17 0.759067 64.17 1.08789C64.17 1.32676 64.0253 1.53172 63.8194 1.62609Z",
    fill: "#3FAF75"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M63.315 7.92976C63.6477 7.92976 63.9162 7.66435 63.9162 7.33553C63.9162 7.22199 63.8819 7.11582 63.8252 7.02588C64.0281 7.12172 64.1699 7.32373 64.1699 7.56113C64.1699 7.88995 63.9013 8.15536 63.5686 8.15536C63.3523 8.15536 63.1628 8.04035 63.0583 7.87078C63.1359 7.90764 63.2225 7.92976 63.315 7.92976Z",
    fill: "#378E60"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72455 1.68114C7.05662 1.68114 7.32582 1.4151 7.32582 1.08691C7.32582 0.758723 7.05662 0.492676 6.72455 0.492676C6.39249 0.492676 6.12329 0.758723 6.12329 1.08691C6.12329 1.4151 6.39249 1.68114 6.72455 1.68114Z",
    fill: "#003E6B"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4739 1.62659C6.41422 1.53369 6.37693 1.4231 6.37693 1.30514C6.37693 0.97632 6.64548 0.710906 6.97819 0.710906C7.06771 0.710906 7.15275 0.731549 7.22884 0.766937C7.12142 0.601791 6.93641 0.492676 6.72455 0.492676C6.39185 0.492676 6.12329 0.75809 6.12329 1.08691C6.12329 1.32726 6.26801 1.53222 6.4739 1.62659Z",
    fill: "#3FAF75"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M6.97819 7.93025C6.64548 7.93025 6.37693 7.66484 6.37693 7.33602C6.37693 7.22248 6.41124 7.11631 6.46794 7.02637C6.26503 7.12221 6.12329 7.32422 6.12329 7.56162C6.12329 7.89044 6.39185 8.15585 6.72455 8.15585C6.94089 8.15585 7.13037 8.04084 7.23481 7.87127C7.15723 7.90813 7.07069 7.93025 6.97819 7.93025Z",
    fill: "#378E60"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color"
    }
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M9.08322 6.72705L7.40625 6.72705L7.40625 14.2073L9.08322 14.2073L9.08322 6.72705Z",
    fill: "#B0E298"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9326 6.72705L11.2556 6.72705L11.2556 14.2073L12.9326 14.2073L12.9326 6.72705Z",
    fill: "#B0E298"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7802 6.72705L15.1033 6.72705L15.1033 14.2073L16.7802 14.2073L16.7802 6.72705Z",
    fill: "#B0E298"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6294 6.72705L18.9524 6.72705L18.9524 14.2073L20.6294 14.2073L20.6294 6.72705Z",
    fill: "#B0E298"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4787 6.72705L22.8018 6.72705L22.8018 14.2073L24.4787 14.2073L24.4787 6.72705Z",
    fill: "#B0E298"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3266 6.72705L26.6497 6.72705L26.6497 14.2073L28.3266 14.2073L28.3266 6.72705Z",
    fill: "#B0E298"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M32.176 6.72705L30.499 6.72705L30.499 14.2073L32.176 14.2073L32.176 6.72705Z",
    fill: "#B0E298"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0251 6.72705L34.3481 6.72705L34.3481 14.2073L36.0251 14.2073L36.0251 6.72705Z",
    fill: "#B0E298"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M39.873 6.72705L38.196 6.72705L38.196 14.2073L39.873 14.2073L39.873 6.72705Z",
    fill: "#B0E298"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7221 6.72705L42.0452 6.72705L42.0452 14.2073L43.7221 14.2073L43.7221 6.72705Z",
    fill: "#B0E298"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5715 6.72705L45.8945 6.72705L45.8945 14.2073L47.5715 14.2073L47.5715 6.72705Z",
    fill: "#B0E298"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4194 6.72705L49.7424 6.72705L49.7424 14.2073L51.4194 14.2073L51.4194 6.72705Z",
    fill: "#B0E298"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2685 6.72705L53.5916 6.72705L53.5916 14.2073L55.2685 14.2073L55.2685 6.72705Z",
    fill: "#B0E298"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1179 6.72705L57.4409 6.72705L57.4409 14.2073L59.1179 14.2073L59.1179 6.72705Z",
    fill: "#B0E298"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9673 6.72705L61.2903 6.72705L61.2903 14.2073L62.9673 14.2073L62.9673 6.72705Z",
    fill: "#B0E298"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color"
    }
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8759 8.64809L6.49777 8.64809C6.03825 8.64809 5.66675 8.28094 5.66675 7.82678L5.66675 0.821311C5.66675 0.367157 6.03825 0 6.49777 -1.14716e-10L63.8744 -8.03504e-09C64.334 -8.09847e-09 64.7055 0.367157 64.7055 0.821311L64.7055 7.82678C64.7069 8.28094 64.334 8.64809 63.8759 8.64809Z",
    fill: "#B0E298"
  }))), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.734128 4.98047H4.37671L4.83203 8.68337H65.5417L65.9971 4.98047H69.2602V12.4618H0.734128V4.98047ZM69.336 12.462H65.0104L69.336 15.8272V16.2404H69.8672L69.336 15.8272V12.462ZM5.05966 12.462H0.734091V15.8272L0.202881 16.2404H0.734091V15.8272L5.05966 12.462Z",
    fill: "#F2F2F2",
    fillOpacity: 0.3
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.7342 64L69.3362 63.3954L65.1624 60.2215L5.28746 60.2215L5.21154 60.2215L4.92065 60.467L0.65834 63.3199L1.54011 63.3199L0.7342 64Z",
    fill: "#758CA2",
    fillOpacity: 0.6
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M5.40673 60.1461L1.00528 63.0933L0.474064 4.67809L4.95141 4.67809L5.40673 8.42336L5.40673 60.1461Z",
    fill: "#99A7AD",
    fillOpacity: 0.6
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1621 60.2549L69.26 63.3198L69.7953 6.31845L65.5415 4.52681L65.1621 8.57436L65.1621 60.2549Z",
    fill: "#99A7AD",
    fillOpacity: 0.6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.21143,
    y: 8.53223,
    width: 1.36597,
    height: 51.6895,
    fill: "#F2F2F2",
    fillOpacity: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 63.7964,
    y: 8.53223,
    width: 1.36597,
    height: 51.6895,
    fill: "#F2F2F2",
    fillOpacity: 0.5
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8465 8.60791L5.1355 52.1359V60.2218H10.9029L62.7338 8.60791H60.8367H48.8465Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1623 9.36328L13.9385 60.2971H16.5945L65.1623 11.9326V9.36328Z",
    fill: "white",
    fillOpacity: 0.2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-99-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.21393 4.14893H5.20288C2.44146 4.14893 0.202881 6.3875 0.202881 9.14893V58.9999C0.202881 61.7613 2.44146 63.9999 5.20289 63.9999H64.8673C67.6287 63.9999 69.8673 61.7613 69.8673 58.9999V9.14893C69.8673 6.48562 67.785 4.30867 65.1596 4.15733C65.0756 6.5877 63.079 8.53219 60.6282 8.53219H9.74564C7.29199 8.53219 5.29353 6.58322 5.21393 4.14893Z"
  }))), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.21393 4.14893H5.20288C2.44146 4.14893 0.202881 6.3875 0.202881 9.14893V58.9999C0.202881 61.7613 2.44146 63.9999 5.20289 63.9999H64.8673C67.6287 63.9999 69.8673 61.7613 69.8673 58.9999V9.14893C69.8673 6.48562 67.785 4.30867 65.1596 4.15733C65.0756 6.5877 63.079 8.53219 60.6282 8.53219H9.74564C7.29199 8.53219 5.29353 6.58322 5.21393 4.14893Z",
    fill: "#F2F2F2",
    fillOpacity: 0.5
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M5.21393 4.14893L12.2102 3.92014L11.9888 -2.85107H5.21393V4.14893ZM65.1596 4.15733L65.5624 -2.83107L58.4109 -3.24331L58.1637 3.91575L65.1596 4.15733ZM5.20288 11.1489H5.21393V-2.85107H5.20288V11.1489ZM7.20288 9.14893C7.20288 10.2535 6.30745 11.1489 5.20288 11.1489V-2.85107C-1.42454 -2.85107 -6.79712 2.52152 -6.79712 9.14893H7.20288ZM7.20288 58.9999V9.14893H-6.79712V58.9999H7.20288ZM5.20289 56.9999C6.30744 56.9999 7.20288 57.8953 7.20288 58.9999H-6.79712C-6.79712 65.6273 -1.42452 70.9999 5.20289 70.9999V56.9999ZM64.8673 56.9999H5.20289V70.9999H64.8673V56.9999ZM62.8673 58.9999C62.8673 57.8953 63.7627 56.9999 64.8673 56.9999V70.9999C71.4947 70.9999 76.8673 65.6273 76.8673 58.9999H62.8673ZM62.8673 9.14893V58.9999H76.8673V9.14893H62.8673ZM64.7567 11.1457C63.7003 11.0848 62.8673 10.2167 62.8673 9.14893H76.8673C76.8673 2.75457 71.8696 -2.4675 65.5624 -2.83107L64.7567 11.1457ZM58.1637 3.91575C58.2095 2.58955 59.2939 1.53219 60.6282 1.53219V15.5322C66.8641 15.5322 71.9418 10.5859 72.1554 4.3989L58.1637 3.91575ZM60.6282 1.53219H9.74564V15.5322H60.6282V1.53219ZM9.74564 1.53219C11.0814 1.53219 12.1668 2.59196 12.2102 3.92014L-1.78233 4.37771C-1.57969 10.5745 3.50262 15.5322 9.74564 15.5322V1.53219Z",
    fill: "#F2F2F2",
    mask: "url(#path-99-inside-1)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.59475 15.3335L9.29297 15.3335V9.24988H7.59475V15.3335Z",
    fill: "#3E6E7A"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.59475 15.3335L9.29297 15.3335V9.24988H7.59475V15.3335Z",
    fill: "#3E6E7A"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.31414 14.6553L9.43018 14.6553V8.53241L7.31414 8.53241V14.6553Z",
    fill: "#3E6E7A"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.29419 15.3223L9.42897 14.6551V8.53223L9.29419 9.19946V15.3223Z",
    fill: "#3E6E7A"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.60276 9.19995L7.31299 8.53271V14.6556L7.60276 15.3228V9.19995Z",
    fill: "#3E6E7A"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7.31299 13.9878V14.6158L7.60276 15.3223H9.29424L9.42902 14.6158V13.9878H7.31299Z",
    fill: "#CCD4E2"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M46.0828 15.3325L47.781 15.3325V9.2489H46.0828V15.3325Z",
    fill: "#3E6E7A"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M46.0828 15.3325L47.781 15.3325V9.2489H46.0828V15.3325Z",
    fill: "#3E6E7A"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M45.7953 14.6553L47.9114 14.6553V8.53241L45.7953 8.53241V14.6553Z",
    fill: "#3E6E7A"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M47.7786 15.3223L47.9134 14.6551V8.53223L47.7786 9.19946V15.3223Z",
    fill: "#3E6E7A"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M46.0804 9.19946L45.7974 8.53223V14.6551L46.0804 15.3223V9.19946Z",
    fill: "#3E6E7A"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M45.7976 13.9878V14.6158L46.0806 15.3223H47.7789L47.9136 14.6158V13.9878H45.7976Z",
    fill: "#CCD4E2"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M49.9136 15.333L51.6118 15.333V9.24939H49.9136V15.333Z",
    fill: "#3E6E7A"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M49.9136 15.333L51.6118 15.333V9.24939H49.9136V15.333Z",
    fill: "#3E6E7A"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M49.6262 14.6553L51.7422 14.6553V8.53241L49.6262 8.53241V14.6553Z",
    fill: "#3E6E7A"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M51.6125 15.3223L51.7406 14.6551V8.53223L51.6125 9.19946V15.3223Z",
    fill: "#3E6E7A"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M49.9144 9.19946L49.6313 8.53223V14.6551L49.9144 15.3223V9.19946Z",
    fill: "#3E6E7A"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M49.6313 13.9878V14.6158L49.9144 15.3223H51.6126L51.7407 14.6158V13.9878H49.6313Z",
    fill: "#CCD4E2"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M62.9519 9.19922H61.2537V15.2828H62.9519V9.19922Z",
    fill: "#3E6E7A"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M62.9519 9.19922H61.2537V15.2828H62.9519V9.19922Z",
    fill: "#3E6E7A"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M63.2349 8.53271H61.1189V14.6556H63.2349V8.53271Z",
    fill: "#3E6E7A"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M61.2537 15.2836L61.1189 14.6163V8.53271L61.2537 9.19995V15.2836Z",
    fill: "#3E6E7A"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M62.9451 9.19946L63.2348 8.53223V14.6158L62.9451 15.2831V9.19946Z",
    fill: "#3E6E7A"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M63.2349 13.9487V14.616L62.9452 15.2832H61.2537L61.1189 14.616V13.9487H63.2349Z",
    fill: "#CCD4E2"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M59.1208 9.19922H57.4226V15.2828H59.1208V9.19922Z",
    fill: "#3E6E7A"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M59.1208 9.19922H57.4226V15.2828H59.1208V9.19922Z",
    fill: "#3E6E7A"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M59.4041 8.53271H57.2881V14.6556H59.4041V8.53271Z",
    fill: "#3E6E7A"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M57.4229 15.2836L57.2881 14.6163V8.53271L57.4229 9.19995V15.2836Z",
    fill: "#3E6E7A"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M59.1211 9.19946L59.4041 8.53223V14.6158L59.1211 15.2831V9.19946Z",
    fill: "#3E6E7A"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M59.4039 13.9487V14.616L59.1208 15.2832H57.4226L57.2878 14.616V13.9487H59.4039Z",
    fill: "#CCD4E2"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M55.2834 9.19922H53.5852V15.2828H55.2834V9.19922Z",
    fill: "#3E6E7A"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M55.2834 9.19922H53.5852V15.2828H55.2834V9.19922Z",
    fill: "#3E6E7A"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M55.5731 8.53271H53.457V14.6556H55.5731V8.53271Z",
    fill: "#3E6E7A"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M53.5851 15.2836L53.457 14.6163V8.53271L53.5851 9.19995V15.2836Z",
    fill: "#3E6E7A"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M55.2834 9.19946L55.5665 8.53223V14.6158L55.2834 15.2831V9.19946Z",
    fill: "#3E6E7A"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M55.5663 13.9487V14.616L55.2833 15.2832H53.5851L53.457 14.616V13.9487H55.5663Z",
    fill: "#CCD4E2"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M26.7547 15.3325L28.4529 15.3325V9.2489H26.7547V15.3325Z",
    fill: "#3E6E7A"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M26.7547 15.3325L28.4529 15.3325V9.2489H26.7547V15.3325Z",
    fill: "#3E6E7A"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M26.4672 14.6553L28.5833 14.6553V8.53241L26.4672 8.53241V14.6553Z",
    fill: "#3E6E7A"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M28.4504 15.3223L28.5852 14.6551V8.53223L28.4504 9.19946V15.3223Z",
    fill: "#3E6E7A"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M26.7525 9.19946L26.4695 8.53223V14.6551L26.7525 15.3223V9.19946Z",
    fill: "#3E6E7A"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M26.4695 13.9878V14.6158L26.7525 15.3223H28.4507L28.5855 14.6158V13.9878H26.4695Z",
    fill: "#CCD4E2"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M30.5855 15.333L32.2837 15.333V9.24939H30.5855V15.333Z",
    fill: "#3E6E7A"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M30.5855 15.333L32.2837 15.333V9.24939H30.5855V15.333Z",
    fill: "#3E6E7A"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M30.2983 14.6553L32.4143 14.6553V8.53241L30.2983 8.53241V14.6553Z",
    fill: "#3E6E7A"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M32.2844 15.3223L32.4125 14.6551V8.53223L32.2844 9.19946V15.3223Z",
    fill: "#3E6E7A"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M30.5863 9.19946L30.3032 8.53223V14.6551L30.5863 15.3223V9.19946Z",
    fill: "#3E6E7A"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M30.3032 13.9878V14.6158L30.5863 15.3223H32.2845L32.4125 14.6158V13.9878H30.3032Z",
    fill: "#CCD4E2"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M43.6235 9.19922H41.9253V15.2828H43.6235V9.19922Z",
    fill: "#3E6E7A"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M43.6235 9.19922H41.9253V15.2828H43.6235V9.19922Z",
    fill: "#3E6E7A"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M43.9066 8.53271H41.7905V14.6556H43.9066V8.53271Z",
    fill: "#3E6E7A"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M41.9253 15.2836L41.7905 14.6163V8.53271L41.9253 9.19995V15.2836Z",
    fill: "#3E6E7A"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M43.6167 9.19946L43.9065 8.53223V14.6158L43.6167 15.2831V9.19946Z",
    fill: "#3E6E7A"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M43.9066 13.9487V14.616L43.6168 15.2832H41.9253L41.7905 14.616V13.9487H43.9066Z",
    fill: "#CCD4E2"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M39.9668 9.19922H38.2686V15.2828H39.9668V9.19922Z",
    fill: "#3E6E7A"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M39.9668 9.19922H38.2686V15.2828H39.9668V9.19922Z",
    fill: "#3E6E7A"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M40.2498 8.53271H38.1338V14.6556H40.2498V8.53271Z",
    fill: "#3E6E7A"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M38.2686 15.2836L38.1338 14.6163V8.53271L38.2686 9.19995V15.2836Z",
    fill: "#3E6E7A"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M39.9668 9.19946L40.2498 8.53223V14.6158L39.9668 15.2831V9.19946Z",
    fill: "#3E6E7A"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M40.2498 13.9487V14.616L39.9668 15.2832H38.2686L38.1338 14.616V13.9487H40.2498Z",
    fill: "#CCD4E2"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M35.9551 9.19922H34.2568V15.2828H35.9551V9.19922Z",
    fill: "#3E6E7A"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M35.9551 9.19922H34.2568V15.2828H35.9551V9.19922Z",
    fill: "#3E6E7A"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M36.2449 8.53271H34.1289V14.6556H36.2449V8.53271Z",
    fill: "#3E6E7A"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M34.2569 15.2836L34.1289 14.6163V8.53271L34.2569 9.19995V15.2836Z",
    fill: "#3E6E7A"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M35.9551 9.19946L36.2381 8.53223V14.6158L35.9551 15.2831V9.19946Z",
    fill: "#3E6E7A"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M36.2382 13.9487V14.616L35.9552 15.2832H34.2569L34.1289 14.616V13.9487H36.2382Z",
    fill: "#CCD4E2"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.4312 15.3325L13.1294 15.3325V9.2489H11.4312V15.3325Z",
    fill: "#3E6E7A"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.4312 15.3325L13.1294 15.3325V9.2489H11.4312V15.3325Z",
    fill: "#3E6E7A"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.1437 14.6553L13.2598 14.6553V8.53241L11.1437 8.53241V14.6553Z",
    fill: "#3E6E7A"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.127 15.3223L13.2617 14.6551V8.53223L13.127 9.19946V15.3223Z",
    fill: "#3E6E7A"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.429 9.19946L11.146 8.53223V14.6551L11.429 15.3223V9.19946Z",
    fill: "#3E6E7A"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M11.146 13.9878V14.6158L11.429 15.3223H13.1273L13.262 14.6158V13.9878H11.146Z",
    fill: "#CCD4E2"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.2622 15.3325L16.9604 15.3325V9.2489H15.2622V15.3325Z",
    fill: "#3E6E7A"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.2622 15.3325L16.9604 15.3325V9.2489H15.2622V15.3325Z",
    fill: "#3E6E7A"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M14.9748 14.6553L17.0908 14.6553V8.53241L14.9748 8.53241V14.6553Z",
    fill: "#3E6E7A"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M16.9614 15.3223L17.0895 14.6551V8.53223L16.9614 9.19946V15.3223Z",
    fill: "#3E6E7A"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.263 9.19946L14.98 8.53223V14.6551L15.263 15.3223V9.19946Z",
    fill: "#3E6E7A"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M14.98 13.9878V14.6158L15.263 15.3223H16.9612L17.0893 14.6158V13.9878H14.98Z",
    fill: "#CCD4E2"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M24.6433 9.19922H22.9451V15.2828H24.6433V9.19922Z",
    fill: "#3E6E7A"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M24.6433 9.19922H22.9451V15.2828H24.6433V9.19922Z",
    fill: "#3E6E7A"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M24.9266 8.53271H22.8105V14.6556H24.9266V8.53271Z",
    fill: "#3E6E7A"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M22.9453 15.2836L22.8105 14.6163V8.53271L22.9453 9.19995V15.2836Z",
    fill: "#3E6E7A"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M24.6436 9.19946L24.9266 8.53223V14.6158L24.6436 15.2831V9.19946Z",
    fill: "#3E6E7A"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M24.9266 13.9487V14.616L24.6435 15.2832H22.9453L22.8105 14.616V13.9487H24.9266Z",
    fill: "#CCD4E2"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M20.6318 9.19922H18.9336V15.2828H20.6318V9.19922Z",
    fill: "#3E6E7A"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M20.6318 9.19922H18.9336V15.2828H20.6318V9.19922Z",
    fill: "#3E6E7A"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M20.9217 8.53271H18.8057V14.6556H20.9217V8.53271Z",
    fill: "#3E6E7A"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M18.9337 15.2836L18.8057 14.6163V8.53271L18.9337 9.19995V15.2836Z",
    fill: "#3E6E7A"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M20.6321 9.19946L20.9151 8.53223V14.6158L20.6321 15.2831V9.19946Z",
    fill: "#3E6E7A"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M20.915 13.9487V14.616L20.6319 15.2832H18.9337L18.8057 14.616V13.9487H20.915Z",
    fill: "#CCD4E2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M0.202881 57.1987H69.8673V59C69.8673 61.7614 67.6287 64 64.8673 64H5.20289C2.44146 64 0.202881 61.7614 0.202881 59V57.1987Z",
    fill: "white"
  }))), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.18714 55.4395H0V59C0 61.7614 2.23858 64 5 64H13.1871C10.4257 64 8.18714 61.7614 8.18714 59V55.4395Z",
    fill: "#E5ECF0"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.8129 55.4395H70V59C70 61.7614 67.7614 64 65 64H56.8129C59.5743 64 61.8129 61.7614 61.8129 59V55.4395Z",
    fill: "#E5ECF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolyacrylamideGel);
export default __webpack_public_path__ + "static/media/Polyacrylamide_Gel.26fb1d745aaf3b9b06300e0c3f940a47.svg";
export { ForwardRef as ReactComponent };